// See: https://docs.microsoft.com/en-us/openspecs/office_standards/ms-oe376/6c085406-a698-4e12-9d4d-c3b0ee3dbc4a

// BCP 47 Code
const locales = {
  Bulgarian: 'bg-BG',
  Czech: 'cs-CZ',
  Danish: 'da-DK',
  German: 'de-DE',
  Greek: 'el-GR',
  English: 'en-US',
  Dutch: 'nl-NL',
  Spanish: 'es-ES',
  Finnish: 'fi-FI',
  Filipino: 'fil-PH',
  French: 'fr-FR',
  Hindi: 'hi-IN',
  Croatian: 'hr-HR',
  Hungarian: 'hu-HU',
  Indonesian: 'id-ID',
  Italian: 'it-IT',
  Korean: 'ko-KR',
  Latvian: 'lv-LV',
  Lithuanian: 'lt-LT',
  Malay: 'ms-MY',
  Polish: 'pl-PL',
  Portugese: 'pt-BR',
  ChineseTrad: 'zh-Hant',
  ChineseSimplified: 'zh-Hans',
  Japanese: 'ja-JP',
  Norwegian: 'nb-NO',
  Romanian: 'ro-RO',
  Russian: 'ru-RU',
  Slovenian: 'sl-SI',
  Swedish: 'sv-SE',
  Thai: 'th-TH',
  Turkish: 'tr-TR',
  Ukrainian: 'uk-UA',
  Vietnamese: 'vi-VN',
};

// Language Code (LCID)
const culturesWithStaticData = {
  [locales.German]: '1031',
  [locales.English]: '1033',
  [locales.Dutch]: '1043',
  [locales.Spanish]: '3082',
  [locales.Filipino]: '1124',
  [locales.French]: '1036',
  [locales.Italian]: '1040',
  [locales.Korean]: '1042',
  [locales.Japanese]: '1041',
  [locales.Portugese]: '1046',
  [locales.ChineseTrad]: '3076',
  [locales.ChineseSimplified]: '2052',
  [locales.Russian]: '1049',
  [locales.Thai]: '1054',
  [locales.Turkish]: '1055',
  [locales.Swedish]: '1053',
  [locales.Finnish]: '1035',
  [locales.Norwegian]: '1044',
  [locales.Czech]: '1029',
  [locales.Ukrainian]: '1058',
  [locales.Indonesian]: '1057',
  [locales.Polish]: '1045',
  [locales.Vietnamese]: '1066',
  [locales.Malay]: '1086',
  [locales.Romanian]: '1048',
  [locales.Greek]: '1032',
  [locales.Hungarian]: '1038',
  [locales.Hindi]: '1081',
  [locales.Bulgarian]: '1026',
  [locales.Danish]: '1030',
  [locales.Lithuanian]: '1063',
  [locales.Croatian]: '1050',
  [locales.Latvian]: '1062',
  [locales.Slovenian]: '1060',
};

module.exports = {
  locales,
  culturesWithStaticData,
};
